import { Extension } from '@tiptap/core';

/**
 * Tab / Shift+Tab indent and outdent list items without ever leaving the editor while the cursor
 * is in a list. StarterKit's list item already maps Tab to "sink", but when an item can't move
 * (e.g. the first item of a list) it declines and the browser moves focus to the next field.
 * Outside lists Tab keeps its normal meaning, so keyboard users can still tab out of the editor.
 */
export const ListTabIndent = Extension.create({
  name: 'listTabIndent',
  // Runs before StarterKit's list item shortcuts (default priority 100).
  priority: 101,

  addKeyboardShortcuts() {
    const inList = () => this.editor.isActive('listItem');
    return {
      Tab: () => {
        if (!inList()) return false;
        this.editor.commands.sinkListItem('listItem');
        return true;
      },
      'Shift-Tab': () => {
        if (!inList()) return false;
        this.editor.commands.liftListItem('listItem');
        return true;
      },
    };
  },
});
